import Layout from './layout';
import ClubBookingSchedule from './pages/ClubBookingSchedule';
import Home from './pages/Home';
import NotFound from './pages/Notfound';
import RequestList from './pages/RequestList';
import SearchScheduleList from './pages/Schedule';
import SignIn from './pages/SignIn';
import TodayBooking from './pages/TodayBooking';
import AddBookingPlacePage from './pages/admin/AddBookingPlacePage';
import BookingPlaceList from './pages/admin/BookingPlaceList';
import BookingScheduleAdmin from './pages/admin/BookingSchedule';
import PlaceScheduleList from './pages/admin/PlaceScheduleList';
import AdminRequestList from './pages/admin/RequestList';

const routes = [
  {
    path: '*',
    element: <NotFound />,
  },
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: 'signin',
        element: <SignIn />,
      },
      {
        path: 'schedule',
        element: <SearchScheduleList />,
      },
      {
        path: 'schedule/request',
        element: <RequestList />,
      },
      {
        path: 'schedule/club',
        element: <ClubBookingSchedule />,
      },
      {
        path: 'booking',
        element: <TodayBooking />,
      },
      {
        path: 'admin',
        children: [
          {
            path: 'add-booking-place',
            element: <AddBookingPlacePage />,
          },
          {
            path: 'schedule',
            element: <BookingScheduleAdmin />,
          },
          {
            path: 'booking-place-list',
            children: [
              {
                path: '',
                element: <BookingPlaceList />,
              },
              {
                path: 'schedule/:itemId',
                element: <PlaceScheduleList />,
              },
            ],
          },
          {
            path: 'schedule/request',
            element: <AdminRequestList />,
          },
        ],
      },
    ],
  },
];

export default routes;
